'use strict';

angular.module('controllers')
	.directive('include', ['$templateRequest', '$compile', function ($templateRequest, $compile) {
		return {
			replace: true,
			restrict: 'A',
			link: function (scope, element, attr) {

				var elInput = angular.element(document.querySelectorAll('input, textarea, md-select'));
				elInput.bind('focus', function (ev) {
					elInput.closest('md-card').attr('draggable', false);
				});
				elInput.bind('blur', function (ev) {
					elInput.closest('md-card').attr('draggable', true);
				});

				if (!attr.include) {
					console.log('include: template url must be provided');
				}else {
					$templateRequest(attr.include).then(function(html){
						// var template = angular.element('<div>'+html+'</div>');
						var template = angular.element(html);
						if(template.length != 0) {
							if (!angular.isUndefined(template[0].tagName)) {
								element.append(template);
								$compile(template)(scope);
							} else {
								//console.log('include: '+attr.include+' template not exist');
							}
						}
					});
				}
			}
		};

	}]);


